module.exports = __webpack_public_path__ + "img/reinforcement-plans.2fdc7c83.jpg";